import { render, staticRenderFns } from "./Biserica.vue?vue&type=template&id=4adf713a&"
import script from "./Biserica.vue?vue&type=script&lang=js&"
export * from "./Biserica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports